<template>
  <div data-component="base-search-query-date-range-value">
    <base-search-query-labels
      :param="param"
      :schema="schema"
    />

    <span
      v-if="param.value && param.value.from"
      data-label="search-param-value"
      :title="dateFromLabel"
    >
      <span class="text">{{ dateFromLabel }}</span>
    </span>

    <span
      v-if="param.value && param.value.to"
      data-label="search-param-value"
      :title="dateToLabel"
    >
      <span class="text">{{ dateToLabel }}</span>

      <div
        data-button="delete-param"
        @click="$emit('delete-param', param)"
      >
        <or-icon icon="close" />
      </div>
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';
import { OrIconV3 as OrIcon } from '@onereach/ui-components-25';

import BaseSearchQueryLabels from './BaseSearchQueryLabels.vue';
import { useSearchQueryParam } from '../../composables';
import { PARAM_PROP, SCHEMA_PROP } from '../../constants';

export default defineComponent({
  name: 'BaseSearchQueryDateRangeValue',
  components: { BaseSearchQueryLabels, OrIcon },
  props: {
    param: PARAM_PROP,
    schema: SCHEMA_PROP,
  },
  setup(props) {
    const { dateFromLabel, dateToLabel } = useSearchQueryParam(props);
    return { dateFromLabel, dateToLabel };
  },
});
</script>

<style lang="scss" scoped>
@use '../../styles' as *;

[data-component='base-search-query-date-range-value'] {
  @include base-search-query-tags;
}
</style>
